






































import { SfRadio, SfButton, SfImage } from '~/components/StorefrontUi';
import {
  computed, defineComponent, onMounted, useRouter, useContext,
} from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import userBillingGetters from '~/modules/customer/getters/userBillingGetters';
import UserAddressDetails from '~/components/UserAddressDetails.vue';
import type { Country, CustomerAddress } from '~/modules/GraphQL/types';
import { addBasePath } from '~/helpers/addBasePath';

export default defineComponent({
  name: 'UserBillingAddresses',
  components: {
    SfRadio,
    UserAddressDetails,
    SfButton,
    SfImage,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    billingAddresses: {
      type: Array as PropType<CustomerAddress[]>,
      required: true,
    },
    countries: {
      type: Array as PropType<Country[]>,
      default: () => [],
    },
    currentAddressId: {
      type: Number as PropType<number | null>,
      default: null,
    },
  },
  emits: ['setCurrentAddress'],
  setup(props, { emit }) {
    const emitSetCurrentAddress = (addressId: number) => {
      const address = props.billingAddresses.find(({ id }) => id === Number(addressId));
      if (address) {
        emit('setCurrentAddress', address);
      }
    };
    const addressesWithCountryName = computed(() => props.billingAddresses.map((address) => ({
      ...address,
      countryName: props.countries
        .find(({ id }) => id === address.country_code)
        ?.full_name_locale
        ?? address.country_code,
    })));
    const router = useRouter();
    const context = useContext();
    const goToEditAddressPage = (addressId: number) => router.push(
      context.localeRoute({ name: 'customer-addresses-details-edit', params: { addressId: String(addressId) } }),
    );

    onMounted(() => {
      const defaultAddressId = addressesWithCountryName.value.find((address) => address.default_billing)?.id;
      emitSetCurrentAddress(defaultAddressId || addressesWithCountryName.value[0]?.id);
    });

    return {
      emitSetCurrentAddress,
      addressesWithCountryName,
      userBillingGetters,
      addBasePath,
      goToEditAddressPage,
    };
  },
});
